"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Filters = _interopRequireDefault(require("../../models/transform/filter/Filters"));

var _isEmpty = _interopRequireDefault(require("../../utils/object/isEmpty"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _creative = require("../../constants/creative");

var _deepEqual = _interopRequireDefault(require("../../utils/object/deepEqual"));

var LayerTransformData = /*#__PURE__*/function () {
  (0, _createClass2["default"])(LayerTransformData, null, [{
    key: "isLayerTransformData",
    value: function isLayerTransformData(layerTransformData) {
      return layerTransformData instanceof LayerTransformData;
    }
  }]);

  function LayerTransformData(contentDimensionMode, contentX, contentY, contentWidth, contentHeight, contentScaleX, contentScaleY, alpha, rotation, scale, translation, alphaCompositeRule, visible, filters) {
    (0, _classCallCheck2["default"])(this, LayerTransformData);
    (0, _defineProperty2["default"])(this, "_alpha", 1);
    (0, _defineProperty2["default"])(this, "_alphaCompositeRule", _creative.DEFAULT_ALPHA_BLEND_MODE);
    (0, _defineProperty2["default"])(this, "_contentDimensionMode", null);
    (0, _defineProperty2["default"])(this, "_contentHeight", 0);
    (0, _defineProperty2["default"])(this, "_contentScaleX", 1);
    (0, _defineProperty2["default"])(this, "_contentScaleY", 1);
    (0, _defineProperty2["default"])(this, "_contentWidth", 0);
    (0, _defineProperty2["default"])(this, "_contentX", 0);
    (0, _defineProperty2["default"])(this, "_contentY", 0);
    (0, _defineProperty2["default"])(this, "_filters", null);
    (0, _defineProperty2["default"])(this, "_rotation", 0);
    (0, _defineProperty2["default"])(this, "_scaledWidth", 1);
    (0, _defineProperty2["default"])(this, "_scaledHeight", 1);
    (0, _defineProperty2["default"])(this, "_scaledTransformX", 0);
    (0, _defineProperty2["default"])(this, "_scaledTransformY", 0);
    (0, _defineProperty2["default"])(this, "_scaleX", 1);
    (0, _defineProperty2["default"])(this, "_scaleY", 1);
    (0, _defineProperty2["default"])(this, "_translationX", 0);
    (0, _defineProperty2["default"])(this, "_translationY", 0);
    (0, _defineProperty2["default"])(this, "_visible", true);
    this._contentDimensionMode = contentDimensionMode;
    this._contentX = contentX;
    this._contentY = contentY;
    this._contentWidth = contentWidth;
    this._contentHeight = contentHeight;

    if ((0, _isNotNil["default"])(contentScaleX)) {
      this._contentScaleX = contentScaleX;
    }

    if ((0, _isNotNil["default"])(contentScaleY)) {
      this._contentScaleY = contentScaleY;
    }

    if ((0, _isNotNil["default"])(alpha)) {
      this._alpha = alpha;
    }

    if ((0, _isNotNil["default"])(rotation)) {
      this._rotation = rotation;
    }

    if ((0, _isNotNil["default"])(scale)) {
      this._scaleX = scale.x;
      this._scaleY = scale.y;
    }

    if ((0, _isNotNil["default"])(translation)) {
      this._translationX = translation.x;
      this._translationY = translation.y;
    } // Adjust the scale and position based on scaled dimensions and objects natural scale.


    this._scaledWidth = this._contentWidth * this._contentScaleX;
    this._scaledHeight = this._contentHeight * this._contentScaleY;
    this._scaledTransformX = -this._scaledWidth / 2;
    this._scaledTransformY = -this._scaledHeight / 2;

    if ((0, _isNotNil["default"])(alphaCompositeRule)) {
      this._alphaCompositeRule = alphaCompositeRule;
    }

    this._visible = Boolean(visible);

    if (!(0, _isEmpty["default"])(filters)) {
      this._filters = _Filters["default"].fromJSON(filters);
    }
  }

  (0, _createClass2["default"])(LayerTransformData, [{
    key: "equals",
    value: function equals(
    /* LayerTransformData */
    inLayerTransformData) {
      if (!LayerTransformData.isLayerTransformData(inLayerTransformData)) return false;
      if (this === inLayerTransformData) return true;
      return this.alpha === inLayerTransformData.alpha && this.alphaCompositeRule === inLayerTransformData.alphaCompositeRule && this.contentDimensionMode === inLayerTransformData.contentDimensionMode && this.contentHeight === inLayerTransformData.contentHeight && this.contentScaleX === inLayerTransformData.contentScaleX && this.contentScaleY === inLayerTransformData.contentScaleY && this.contentWidth === inLayerTransformData.contentWidth && this.contentX === inLayerTransformData.contentX && this.contentY === inLayerTransformData.contentY && this.rotation === inLayerTransformData.rotation && this.scaleX === inLayerTransformData.scaleX && this.scaleY === inLayerTransformData.scaleY && this.scaledHeight === inLayerTransformData.scaledHeight && this.scaledTransformX === inLayerTransformData.scaledTransformX && this.scaledTransformY === inLayerTransformData.scaledTransformY && this.scaledWidth === inLayerTransformData.scaledWidth && this.translationX === inLayerTransformData.translationX && this.translationY === inLayerTransformData.translationY && this.visible === inLayerTransformData.visible && (0, _deepEqual["default"])(this.filters, inLayerTransformData.filters);
    }
  }, {
    key: "alpha",
    get: function get() {
      return this._alpha;
    }
  }, {
    key: "alphaCompositeRule",
    get: function get() {
      return this._alphaCompositeRule;
    }
  }, {
    key: "contentDimensionMode",
    get: function get() {
      return this._contentDimensionMode;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this._contentHeight;
    }
  }, {
    key: "contentScaleX",
    get: function get() {
      return this._contentScaleX;
    }
  }, {
    key: "contentScaleY",
    get: function get() {
      return this._contentScaleY;
    }
  }, {
    key: "contentWidth",
    get: function get() {
      return this._contentWidth;
    }
  }, {
    key: "contentX",
    get: function get() {
      return this._contentX;
    }
  }, {
    key: "contentY",
    get: function get() {
      return this._contentY;
    }
  }, {
    key: "filters",
    get: function get() {
      return this._filters;
    }
  }, {
    key: "rotation",
    get: function get() {
      return this._rotation;
    }
  }, {
    key: "scaledWidth",
    get: function get() {
      return this._scaledWidth;
    }
  }, {
    key: "scaledHeight",
    get: function get() {
      return this._scaledHeight;
    }
  }, {
    key: "scaledTransformX",
    get: function get() {
      return this._scaledTransformX;
    }
  }, {
    key: "scaledTransformY",
    get: function get() {
      return this._scaledTransformY;
    }
  }, {
    key: "scaleX",
    get: function get() {
      // Combine all scales to get final width
      return this._scaleX;
    }
  }, {
    key: "scaleY",
    get: function get() {
      // Combine all scales to get final height
      return this._scaleY;
    }
  }, {
    key: "translationX",
    get: function get() {
      return this._translationX;
    }
  }, {
    key: "translationY",
    get: function get() {
      return this._translationY;
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    }
  }]);
  return LayerTransformData;
}();

exports["default"] = LayerTransformData;